import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DASHBOARD from "../components/dashboard/Dashboard.component";
import BASE_LAYOUT from "../components/layout/BaseLayout.component";
import { ViewContainer } from "./View.styles";
import { IViewProps } from "./View.types";

const DASHBOARD_VIEW: React.FC<IViewProps> = ({ pageTitle }) => (
  <BASE_LAYOUT>
    <ViewContainer fluid className="cms-soar-view-container">
      <DASHBOARD />
    </ViewContainer>
  </BASE_LAYOUT>
);

export default DASHBOARD_VIEW;
